import { useState } from "react"
import {
  buildBasicFilterValues,
  buildPrefixedFilterValue,
} from "../../utils/tables/filtering.utils"

export function useTaskReportsFilters(filterConfig) {
  const [columnFilters, setColumnFilters] = useState(
    /** @type {import("@tanstack/react-table").ColumnFiltersState} */ ([])
  )

  function getFilterValues(table) {
    const categoryFilterValue = table
      .getColumn("categoryTitle")
      ?.getFilterValue()

    return {
      ...buildBasicFilterValues(filterConfig, table),
      ...(categoryFilterValue ?
        {
          categoryId: buildPrefixedFilterValue(categoryFilterValue, "normal:"),
          specialCategoryId: buildPrefixedFilterValue(
            categoryFilterValue,
            "special:"
          ),
        }
      : {}),
    }
  }

  function setFilter(table, field, value) {
    table.getColumn(field)?.setFilterValue(value)
  }

  return {
    columnFilters,
    setColumnFilters,
    getFilterValues,
    setFilter,
  }
}
